import en from './en_EN.json'

export const defaultLocale = 'en'

export const languages = {
    en: en
}